<template><div>
  About
  <pre v-html="info" />
</div></template>
<script>
export default {
  name: 'unit-vpn-about',
  props: ['api','info'],
}
</script>
